export const APP_LOADED = 'APP_LOADED';
export const PATH_CHANGE = 'PATH_CHANGE';
export const APP_LOADED_SUCCESSFULLY = 'APP_LOADED_SUCCESSFULLY';
export const APP_LOADED_UNSUCCESSFULLY = 'APP_LOADED_UNSUCCESSFULLY';

export const appLoaded = () => ({
  type: APP_LOADED,
});
